<template>
  <div v-if="hasValidUrl" class="product-information__extended-info">
    <p v-if="description" class="product-information__extended-info-title">
      {{ description }}
    </p>
    <p class="product-information__extended-link">
      <a :href="url" target="_blank" rel="noopener noreferrer">
        {{ displayText }}
      </a>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    url: {
      type: String,
      default: null
    },
    linkText: {
      type: String,
      default: null
    },
    description: {
      type: String,
      default: null
    }
  },
  computed: {
    hasValidUrl() {
      // If Link Text exists but URL is empty, nothing should be displayed
      if (!this.url && this.linkText) {
        return false
      }

      // If URL is empty, nothing should be displayed
      return !!this.url
    },
    displayText() {
      return this.linkText || this.url
    }
  }
}
</script>

<style lang="scss">
.product-information__extended-info {
  margin-bottom: measure(half);
}

// .product-information__extended-info-title {
//   margin: 0 0 measure(eighth) 0;
// }

// .product-information__extended-link {
//   margin: 0;
//   padding-left: measure(quarter);
//   border-left: 4px solid color(brand-yellow);
// }

// .product-information__extended-link a {
//   @include body;
//   color: color(text-link);
//   text-decoration: underline;

//   &:hover {
//     text-decoration: none;
//   }
// }
</style>
